import React from 'react';
import {createRoot} from 'react-dom/client';
import {IntlProvider} from 'react-intl';
import {Provider} from 'react-redux';

import createStoreWithMiddleware from 'state/createStoreWithMiddleware';
import store from 'state/store';

import RouterProvider from 'components/RouterProvider';

class Renderer {
  constructor() {
    this.store = createStoreWithMiddleware(store);
  }

  render(element, options) {
    options = {scrollToTop: true, ...options};
    if (options.scrollToTop) {
      window.scrollTo(0, 0);
    }
    createRoot(document.getElementById('app')).render(
      <RouterProvider>
        <IntlProvider locale={ENV.locale} messages={ENV.messages}>
          <Provider store={this.store}>{element}</Provider>
        </IntlProvider>
      </RouterProvider>,
    );
  }
}

export default new Renderer();
